// route-paths.ts
import { environment } from '../../../environments/environment';

export class RoutePaths {

  // ===============================
  // 🔌 Endpoints
  // ===============================
  public static readonly SOCKET = `${environment.ApiHost.host}:${environment.ApiHost.WebPort}`;
  public static readonly API_ENDPOINT = `http://${environment.ApiHost.host}:4200`;


  // ===============================
  // 🏠 Common Routes
  // ===============================
  public static readonly COMMON = Object.freeze({
    HOME: 'home',
    ROOM_STATUS: 'room-status',
    MASTER: 'master',
    CUSTOMET_DETAIL: 'customer-detail',
     CRF: 'CRF',
    NEW_ENQUIRY:'new-enquiry',
    ADMIN: 'admin',
    SAMPLE_VERIFICATION:'sample-verification',
    AUDIT_TRAIL: 'audit-trail',
    VIEW_PROFILE: 'view-profile',
    ADMIN_CHANGE_PROFILE: 'admin-change-profile',
    REPORT: 'report'
  });


  // ===============================
  // 🔐 Policy Routes
  // ===============================
  public static readonly POLICY = Object.freeze({
    PASSWORD_POLICY: 'pwd-policy',
    SET_ALL_PARAMETER: 'set-all-parameter'
  });


  // ===============================
  // 🧭 Master → Department
  // ===============================
  public static readonly DEPARTMENT = Object.freeze({
    LIST: 'department',
    ADD: 'add-department',
    EDIT: 'edit-department'
  });

  // ===============================
  // 🧭 Master → Designation
  // ===============================
  public static readonly DESIGNATION = Object.freeze({
    LIST: 'designation',
    ADD: 'add-designation',
    EDIT: 'edit-designation'
  });

  // ===============================
  // 🧭 Master → Category
  // ===============================
  public static readonly CATEGORY = Object.freeze({
    LIST: 'category',
    ADD: 'add-category',
    VIEW: 'view-category'
  });


  // ===============================
  // 🧭 Master → Role
  // ===============================
  public static readonly ROLE = Object.freeze({
    LIST: 'role',
    ADD: 'add-role',
    EDIT: 'edit-role'
  });

  
  // ===============================
  // 🧭 Master → User
  // ===============================
  public static readonly USER = Object.freeze({
    LIST: 'user',
    ADD: 'add-user',
    MANAGE: 'manage-user',
    EDIT: 'edit-user'
  });


  // ===============================
  // 🧭 Master → Inspection & TestType
  // ===============================
  public static readonly INSPECTION = Object.freeze({
    LIST: 'inspectionchecklist',
    TESTTYPE: 'testtype',
    ADD: 'add-inspection',
    ADD_TESTTYPE: 'add-testtype',
    EDIT: 'edit-inspection',
    EDIT_TESTTYPE: 'edit-testtype'
  });

    // ===============================
  // 🧭 Master → customerDetail
  // ===============================
  public static readonly CUTOMERDETAIL = Object.freeze({
    LIST: 'customerdetail',
    ADD: 'add-customerdetail',
    MANAGE: 'manage-customerdetail',
    EDIT: 'edit-customerdetail'
  });

      // ===============================
  // 🧭 Master → CRF
  // ===============================
  public static readonly CRF = Object.freeze({
    LIST: 'CRF',
    ADD: 'add-crf',
    MANAGE: 'manage-crf',
    EDIT: 'edit-'
  });

   // ===============================
  // 🧭 Master → newEnquiry
  // ===============================
  public static readonly NEWENQUIRY = Object.freeze({
    LIST: 'enquiry',
    ADD: 'add-enquiry',
    VIEW: 'manage-enquiry'
  });

   // ===============================
  // 🧭 Master → sampleVerification
  // ===============================
  public static readonly SAMPLEVERIFICATION = Object.freeze({
    LIST: 'verification',
    ADD: 'sample-verification',
    VIEW: 'sample-list',
    EDIT:'sample-list-verify',
    ALLOCATE:'test-allocation'
  });

  // ===============================
  // 🧭 Task List
  // ===============================
  public static readonly TASKLIST = Object.freeze({
    LIST: 'task-list',
  });



  // ===============================
  // 🧭 Master → Configuration
  // ===============================
  public static readonly CONFIGURATION = 'configuration';


  // ===============================
  // 🧭 Master → Plant
  // ===============================
  public static readonly PLANT = Object.freeze({
    LIST: 'plant',
    ADD: 'add-plant',
    EDIT: 'edit-plant'
  });

  // ===============================
  // 🧭 Master → Area
  // ===============================
  public static readonly AREA = Object.freeze({
    LIST: 'area',
    ADD: 'add-area',
    EDIT: 'edit-area'
  });


  // ===============================
  // 🧭 Master → Test Type
  // ===============================
  public static readonly TEST_TYPE = 'test-type';


  // ===============================
  // 🧭 Master → Report
  // ===============================
  public static readonly MASTER_REPORT = Object.freeze({
    LIST: 'report',
    ADD: 'add-report',
    EDIT: 'edit-report'
  });


  // ===============================
  // 📜 Audit Trail
  // ===============================
  public static readonly AUDIT = Object.freeze({
    ACTIVITY_LOG: 'activity-log',
    CATEGORY: 'audit-category',
    DEPARTMENT: 'audit-department',
    ROLE: 'audit-role',
    USER: 'audit-user',
    TESTTYPE: 'audit_testtype',
    DESIGNATION:'audit_designation',
    ENQUIRY:'audit_enquiry',
    CUSTOMER:'audit_customer',
    CUSTOMERFEEDBACK:'customer_feedbacks',
    CRF:'audit_crf'
  });


  // ===============================
  // 📊 Report
  // ===============================
  public static readonly REPORTS = Object.freeze({
    TESTRESULT: 'Test-Result',
    TESTREPORT: 'Test-Report',
    TEST: 'Test',
    USER_STATUS: 'user-status',
    ROLE_LOG: 'role-log',
    TASKLIST:'task-list',

  });
}
